import { useGetRoomsQuery } from 'shared/api';

export const useTeacherWorkloadForm = (error?: any) => {
  const { data: rooms } = useGetRoomsQuery({ size: 2000 });

  const subjectError = error?.errorFields?.filter((err: any) => err.name[0] === 'subjectRows')?.[0]
    ?.errors?.[0];

  return {
    state: {
      rooms: rooms?.content || [],
      subjectError,
    },
  };
};
